import React, { useEffect, useContext, useState } from "react";
import "../Styles.css";
import "../../../ui-styles/contentHeading/contentHeading.css";
import "../../../ui-styles/inlineLink/inlineLinkIcon.css";
import "../../../ui-styles/nodata/NoData.css";
import { LangCtx, RoleCtx } from "../../../lib/context";
import CardsList from "../../common/CardsList";
import { Link } from "react-router-dom";
import { adminAppointmentReport, adminUserReport, clinicAppointmentReport, clinicUserReport } from "../../../actions/users";
import Loader from "../../../lib/ui/loader/Loader";
import {API} from 'aws-amplify';

const AdminDashboard = (props) => {
    const { l } = useContext(LangCtx);
    const [uloading, setULoading] = useState(false);
    const [aloading, setALoading] = useState(false);
    const [usersReports, setUsersReports] = useState({});
    const [apptReports, setApptReports] = useState({});
    const { role } = useContext(RoleCtx);

    useEffect(() => {
        setULoading(true);
        setALoading(true);
        if (role === 'CA' || role === 'SA') {
            adminUserReport().then(res => {
                setULoading(false);
                if (res.status) {
                    setUsersReports(res.data);
                } else {
                    setUsersReports({});
                }
            }).catch(err => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setULoading(false);
                }
                setUsersReports({});
                console.log("err ==== ", err);
            })
            adminAppointmentReport().then(res => {
                // console.log("res in admin appointment report==========", res);
                if (res.status) {
                    setApptReports(res.data);
                } else {
                    setApptReports({});
                }
            }).catch(err => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setALoading(false);
                }
                setApptReports({});
                console.log("err ==== ", err);
            })
        } else if (role === "C") {
            clinicUserReport().then(res => {
                // console.log("res in clinic usercount =========", res);
                setULoading(false);
                if (res.status) {
                    setUsersReports(...res.data);
                } else {
                    setUsersReports({});
                }
            }).catch(err => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setULoading(false);
                }
                setUsersReports({});
                console.log("err ==== ", err);
            })
            clinicAppointmentReport().then(res => {
                // console.log("res in clinic appoint count =========", res);

                setALoading(false);
                if (res.status) {
                    setApptReports(...res.data);
                } else {
                    setApptReports({});
                }
            }).catch(err => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setALoading(false);
                }
                setApptReports({});
                console.log("err ==== ", err);
            })
        }

    }, [role]);

    return (
        <>
        <div className="baseContainer">
            <div className="hdngTopCol colBlock">
                <div className="hdngTopBox etcPdng">
                    <h2 className="topHdngTxt">{l.dashboard}</h2>
                </div>
                <div className="inlineItemContainer fullWidth">
                    <div className="inlineItemBox">
                        <span className="itmTxt">{l.crt_user_hdng}</span>
                    </div>
                    <div className="inlineItemGroup flexZA">
                        <Link to="/admin-createusers" className="inlineLink Sm"><span className="txtPlus">{l.create_user}</span></Link>
                    </div>
                </div>
            </div>
        {(uloading || aloading) && <Loader />}
        <CardsList usersCount={usersReports} apptCount={apptReports} role={role}/>
        </div>
        </>
    )
}

export default AdminDashboard;
